<template>
    <a-drawer title="编辑订单" placement="right" width="1150px" :closable="true" :visible="show" :maskClosable="false" @close="$emit('close', null)" :afterVisibleChange="onInitInfo">
        <div class="drawer-layer">
            <a-card title="基本信息" style="width: 350px;">
                <div class="card-inner-title">
                    <div>选择用户</div>
                    <div>
                        <a-switch checked-children="常用" un-checked-children="所有" v-model="isUsual" @change="onInitGuest" />
                        <a-input-search class="search-input" placeholder="搜索客户名称" size="small" enter-button v-model="searchedGuest" @search="onInitGuest" />
                    </div>
                </div>
                <div style="color: red; margin-bottom: 10px;">注意事项：更换客户需要重新填写右侧商品列表</div>
                <div style="height: 525px; overflow: scroll;">
                    <a-card class="inner-card" :headStyle="selectedGuestStyle" :title="selectedGuest > 0 ? selectedGuestItem.name : '暂无选中客户'" size="small" :hoverable="true"
                        style="position: sticky; top: 0px; z-index: 99;">
                        <a-descriptions size="small" :column="1" style="color: skyblue !important" v-if="selectedGuest > 0">
                            <a-descriptions-item label="客户类型">{{selectedGuestItem.typename}}</a-descriptions-item>
                            <a-descriptions-item label="联系电话">{{selectedGuestItem.mobile}}</a-descriptions-item>
                            <a-descriptions-item label="联系地址">{{selectedGuestItem.address}}</a-descriptions-item>
                            <a-descriptions-item label="所属区域">{{selectedGuestItem.areaname}}</a-descriptions-item>
                        </a-descriptions>
                    </a-card>
                    <a-card class="inner-card" :headStyle="item.id === selectedGuest ? selectedGuestStyle : {}" :title="item.name" size="small" :hoverable="true" v-for="(item, index) in guestList" :key="index"
                        @click="onSelectGuest(item.id)"></a-card>
                </div>
                <a-form-model ref="modelForm" :model="formModel" layout="horizontal" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }" :rules="formRule">
                    <a-form-model-item label="车辆名称" style="margin-top: 14px;" prop="vehicle_id.value">
                        <a-select placeholder="请选择车辆名称" v-model="formModel.vehicle_id.value">
                            <a-select-option :value="item.id" v-for="(item, index) in formModel.vehicle_id.items" :key="index">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="司机名称" style="margin: 0px;">
                        <a-input :value="driverName" placeholder="" disabled />
                    </a-form-model-item>
                </a-form-model>
            </a-card>
            <div class="table-content">
                <div class="table-button">
                    <a-tooltip v-if="selectedGuest <= 0">
                        <template slot="title">请选择客户</template>
                        <a-button icon="plus">新建商品</a-button>
                    </a-tooltip>
                    <a-button v-else icon="plus" @click="onAddGoods">新建商品</a-button>
                    <a-popover placement="bottomRight" v-model="showPayment" title="支付选项" trigger="click">
                        <div slot="content" v-if="this.tableData.length">
                            <div class="payment-item">
                                <span>支付方式：</span>
                                <a-select placeholder="请选择" v-model="selectedPayment" style="width: 100px">
                                    <a-select-option :value="index" v-for="(item, index) in payment" :key="index">{{item}}</a-select-option>
                                </a-select>
                            </div>
                            <!-- eslint-disable -->
                            <a-input class="payment-item" v-model="arrearsPrice" placeholder="请输入实付金额" v-if="selectedPayment == 2" />
                            <div class="payment-item">
                                <span>提交打印订单：</span>
                                <a-switch v-model="submitPrint"></a-switch>
                            </div>
                            <div class="payment-item" v-if="submitPrint">
                                <span>打印份数：</span>
                                <a-input-number v-model="printCount" :min="1" :max="50" :step="1" style="width: 80px; margin-left: 10px;" />
                            </div>
                            <a-button type="primary" @click="onSubmitOrders" :disabled="selectedPayment == 2 && !arrearsPrice">完成</a-button>
                        </div>
                        <div slot="content" v-else>请新增至少一件商品再进行提交 </div>
                        <a-button icon="check" type="primary">提交订单</a-button>
                    </a-popover>
                </div>
                <a-table style="height: 706px" :columns="columns" :data-source="tableData" :rowKey="(rec) => Math.random() * Math.random()" :pagination="false" :scroll="{ y: 648 }">
                    <div slot="c-action" slot-scope="text, record, index">
                        <a-tooltip v-if="selectedGuest <= 0">
                            <template slot="title">请选择客户</template>
                            <a-icon type="edit" theme="twoTone" />
                        </a-tooltip>
                        <a-icon v-else type="edit" theme="twoTone" @click="onEditGoods(record, index)" />
                        <a-popconfirm placement="bottomRight" title="确定要删除吗？" @confirm="onDeleteGoods(index)">
                            <a-icon style="margin-left: 10px;" type="delete" theme="twoTone" two-tone-color="#eb2f96" />
                        </a-popconfirm>
                    </div>
                </a-table>
                <div class="statistic">
                    <a-statistic :title="item.name" :value="item.value" style="margin-right: 50px" v-for="(item, index) in statistic" :key="index">
                        <template slot="suffix">
                            <div>{{item.unit}}</div>
                        </template>
                    </a-statistic>
                </div>
            </div>
        </div>
        <a-drawer :width="500" :closable="true" :visible="showInner" :maskClosable="false" @close="() => showInner = false" :destroyOnClose="true">
            <a-form-model class="inner-form" ref="innerModelForm" :model="innerFormModal" layout="horizontal" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" :rules="innerFormRule">
                <a-form-model-item label="商品名称" prop="name">
                    <a-cascader v-model="innerFormModal.name" :options="cascaderItems" expand-trigger="hover" placeholder="请选择商品名称" @change="onGoodsNameChange"></a-cascader>
                </a-form-model-item>
                <a-form-model-item label="分组" prop="discount" v-show="selectedGoodsInfo.discount.length">
                    <a-select v-model="innerFormModal.discount" placeholder="请选择分组" @change="onGroupChange">
                        <a-select-option :value="item.id" v-for="(item, index) in selectedGoodsInfo.discount" :key="index">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="总数量" prop="amount">
                    <a-input v-model="innerFormModal.amount" placeholder="请输入总数量" @change="onAmountChange" />
                </a-form-model-item>
                <a-form-model-item label="总重量" prop="weight">
                    <a-input v-model="innerFormModal.weight" placeholder="请输入总重量" :disabled="selectedGoodsRule.weight === '0'" @change="onWeightChange" />
                </a-form-model-item>
                <a-form-model-item label="总价" prop="money">
                    <a-input v-model="innerFormModal.money" placeholder="请输入总价" :disabled="selectedGoodsRule.price === '0'" />
                </a-form-model-item>
                <a-form-model-item label="备注">
                    <a-input v-model="innerFormModal.remark" placeholder="请输入备注" />
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="onSubmitGoods">提交</a-button>
                </a-form-model-item>
            </a-form-model>
        </a-drawer>
    </a-drawer>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    payment
} from '@/common/project-config'
import {
    formModel,
    formRule,
    innerFormModal,
    innerFormRule,
    columns,
    statistic
} from './edit.drawer.conf.js'
import Interpreter from 'js-interpreter'

export default {
    computed: {
        ...mapState('stored', ['userInfo']),
        selectedGuestItem() {
            let items = this.guestList.find((s) => s.id === this.selectedGuest)
            /* eslint-disable vue/no-side-effects-in-computed-properties */
            if (items) {
                this.selectedGuestItemsBack = items
            }
            /* eslint-disable vue/no-side-effects-in-computed-properties */
            return items || this.selectedGuestItemsBack
        },
        driverName() {
            let selectedVehicle = this.formModel.vehicle_id.value
            let selectedItem = this.formModel.vehicle_id.items.find((s) => s.id === selectedVehicle)
            return selectedItem ? selectedItem.drivername : ''
        }
    },
    data() {
        return {
            // 显示二级drawer
            showInner: false,
            // 显示支付方式弹窗
            showPayment: false,
            // 选中的客户id
            selectedGuest: -1,
            // 选择客户信息备份
            selectedGuestItemsBack: {},
            // 选中的商品id
            selectedGoods: -1,
            // 选中商品的规则
            selectedGoodsRule: {
                weight: '0',
                price: '0',
                autoWeight: '1',
                autoPrice: '1',
                formula: 'n*o',
                // 计量单位：0=公斤，1=瓶子
                is_p: 1
            },
            // 选中商品信息
            selectedGoodsInfo: {
                weight: 0,
                origin: 0,
                discount: []
            },
            // 常用客户筛选
            isUsual: true,
            // 客户名称筛选
            searchedGuest: '',
            // 选中的支付方式id
            selectedPayment: '0',
            // 欠款金额
            arrearsPrice: '',
            // 提交打印
            submitPrint: false,
            // 打印份数
            printCount: 1,
            // 一级drawer表单
            formModel: formModel(),
            // 一级drawer表单规则
            formRule: formRule(),
            // 二级drawer表单
            innerFormModal: innerFormModal(),
            // 二级drawer表单规则
            innerFormRule: innerFormRule(),
            // 级联选择选项
            cascaderItems: [],
            // 选中客户的样式
            selectedGuestStyle: {
                backgroundColor: 'aliceblue',
                color: 'skyblue',
                fontWeight: 'bold'
            },
            // 订单信息
            order: {},
            // 商品列表
            goodsList: [],
            // 客户列表
            guestList: [],
            // 支付方式列表
            payment: {
                0: '仅编辑',
                ...payment
            },
            // 商品表配置
            columns: columns(),
            // 商品表数据
            tableData: [],
            // single_type字段
            singleType: -1,
            // 统计数据
            statistic: statistic()
        }
    },
    created() {

    },
    mounted() {

    },
    props: {
        oid: {
            default: -1
        },
        show: {
            default: false
        }
    },
    methods: {
        ...mapMutations('global', ['unsetCachedRoute']),
        // 初始化
        async onInit() {
            await this.onInitGuest()
            await this.onInitVehicle()
            await this.onGetGoods()
            if (this.oid > 0) {
                await this.onGetOrder()
            }
        },
        // 切换抽屉事件
        onInitInfo() {
            if (this.show) {
                this.onInit()
            } else {
                Object.assign(this.$data, this.$options.data())
                this.formModel = formModel()
                this.formRule = formRule()
                this.innerFormModal = innerFormModal()
                this.innerFormRule = innerFormRule()
                this.columns = columns()
                this.statistic = statistic()
                this.printCount = 1
            }
        },
        // 获取订单信息
        async onGetOrder() {
            let res = await this.$util.request(this.$ctrl.order.detail, {
                id: this.oid
            })
            this.tableData = res.data.goods
            this.singleType = res.data.single_type
            this.selectedGuest = res.data.cli_id
            this.formModel.vehicle_id.value = res.data.vehicle_id
            this.statistic[0].value = res.data.sumquantity
            this.statistic[1].value = res.data.sumweight
            this.statistic[2].value = res.data.summoney
        },
        // 初始化客户信息
        async onInitGuest() {
            let res = await this.$util.request(this.$ctrl.guest_source.get, {
                status: this.userInfo.stationId,
                limit: 9999,
                type: this.isUsual ? 1 : undefined,
                name: this.searchedGuest
            })
            this.guestList = res.data.data
        },
        // 初始化车辆信息
        async onInitVehicle() {
            let res = await this.$util.request(this.$ctrl.vehicle.get, {
                status: this.userInfo.stationId,
                type: 1
            })
            this.formModel.vehicle_id.items = res.data.data
            try {
                this.formModel.vehicle_id.value = res.data.data.find((s) => s.type === 1).id
            } catch (err) {
                this.$message.warning('没有车辆信息')
            }
        },
        // 选择客户
        onSelectGuest(e) {
            if (this.selectedGuest !== e) {
                this.selectedGuest = e
                this.tableData = []
                this.calcTotal()
            }
        },
        // 新增商品
        async onAddGoods() {
            if (this.selectedGuest <= 0) {
                return
            }
            this.selectedGoods = -1
            this.innerFormModal.discount = undefined
            this.innerFormModal.amount = undefined
            this.innerFormModal.weight = undefined
            this.innerFormModal.money = undefined
            this.innerFormModal.remark = undefined
            let res = await this.$util.request(this.$ctrl.order.defaultGoods, {
                status: this.userInfo.stationId
            })
            let { name, specification } = res.data
            this.innerFormModal.name = [name, specification]
            await this.onGoodsNameChange([name, specification])
            this.showInner = true
        },
        // 编辑商品
        async onEditGoods(e, f) {
            if (this.selectedGuest <= 0) {
                return
            }
            this.selectedGoods = f
            this.innerFormModal.name = [e.goodsname, e.specification]
            this.innerFormModal.amount = e.amount
            this.innerFormModal.weight = e.weight
            this.innerFormModal.money = e.money
            this.innerFormModal.remark = e.remark
            await this.onGoodsNameChange([e.goodsname, e.specification])
            this.innerFormModal.discount = e.ass_id
            this.showInner = true
        },
        // 删除商品
        onDeleteGoods(e) {
            this.tableData.splice(e, 1)
            this.calcTotal()
        },
        // 提交商品
        onSubmitGoods() {
            this.$refs.innerModelForm.validate((valid) => {
                if (valid) {
                    let datas = {}
                    datas.goodsname = this.innerFormModal.name[0]
                    datas.specification = this.innerFormModal.name[1]
                    datas.ass_id = this.innerFormModal.discount || -1
                    datas.amount = this.innerFormModal.amount
                    datas.weight = this.innerFormModal.weight
                    datas.money = this.innerFormModal.money
                    datas.remark = this.innerFormModal.remark
                    this.innerFormModal.discount = undefined
                    if (this.selectedGoods >= 0) {
                        this.tableData[this.selectedGoods] = datas
                    } else {
                        this.tableData.push(datas)
                    }
                    this.showInner = false
                    this.calcTotal()
                } else {
                    return false
                }
            })
        },
        // 获取商品级联选择
        async onGetGoods() {
            let res = await this.$util.request(this.$ctrl.goods.get, {
                status: this.userInfo.stationId,
                limit: 9999
            })
            this.goodsList = res.data.data
            let firstLayer = Array.from(new Set(res.data.data.map((s) => s.name)))
            this.cascaderItems = firstLayer.map((s) => ({
                value: s,
                label: s,
                children: res.data.data.filter((s0) => s0.name === s).map((s0) => ({
                    value: s0.specification,
                    label: s0.specification
                }))
            }))
        },
        // 商品名称改变事件
        async onGoodsNameChange(e) {
            let selectedGood = this.goodsList.find((s) => s.name === e[0] && s.specification === e[1])
            if (selectedGood) {
                await this.solveRules(selectedGood)
                await this.getGoodsInfo(selectedGood)
            }
            this.calcSingle()
        },
        // 获取商品信息
        async getGoodsInfo(goods) {
            this.selectedGoodsInfo.weight = Number(goods.weight)
            this.selectedGoodsInfo.origin = Number(goods.money)
            let res = await this.$util.request(this.$ctrl.order.group_price, {
                status: this.userInfo.stationId,
                c_id: this.selectedGuest,
                g_id: goods.id
            })
            this.selectedGoodsInfo.discount = res.data
            this.innerFormModal.discount = undefined
        },
        // 总数量变化事件
        onAmountChange() {
            this.calcSingle()
        },
        // 总重量变化事件
        onWeightChange() {
            this.calcSingle()
        },
        // 分组变化事件
        onGroupChange() {
            this.calcSingle()
        },
        // 解析商品规则
        async solveRules(rules) {
            this.selectedGoodsRule = {
                weight: rules.is_weights ? '1' : '0',
                price: rules.is_prices ? '1' : '0',
                autoWeight: rules.is_autoWeights ? '1' : '0',
                autoPrice: rules.is_autoPrices ? '1' : '0',
                formula: rules.rule.replace('总数量', 'n').replace('总重量', 'w').replace('原价', 'o').replace(
                    '分组价格', 'd'
                ),
                is_p: rules.is_p !== undefined ? rules.is_p : 1
            }
        },
        // 解析计算公式
        solveFormula() {
            let _formula = this.selectedGoodsRule.formula
            let amount = this.innerFormModal.amount
            let weight = this.innerFormModal.weight
            let origin = this.selectedGoodsInfo.origin
            let discount = this.selectedGoodsInfo.discount.find((s) => s.id === this.innerFormModal.discount)
            if ((!amount && _formula.indexOf('n') >= 0) || (!weight && _formula.indexOf('w') >= 0)) {
                return null
            }
            _formula = _formula.replace('n', amount)
                .replace('w', weight)
                .replace('o', origin)
                .replace('d', discount ? discount.money : origin)
            return parseFloat(this.calculator(_formula))
        },
        // 安全的计算器
        calculator(expression) {
            // eslint-disable-next-line
            if (/[^1234567890.\+\-\*\/\(\)]/.test(expression)) {
                this.errorCallBack()
                return 0
            } else {
                try {
                    let interpreter = new Interpreter(expression)
                    interpreter.run()
                    if (!Number.isFinite(interpreter.value)) {
                        this.errorCallBack()
                        return 0
                    }
                    return interpreter.value
                } catch (err) {
                    this.errorCallBack()
                    return 0
                }
            }
        },
        // 计算错误的回调方法
        errorCallBack() {
            this.$notification.error({
                message: '错误',
                description: '请检查输入的总数量，总重量是否合法',
                duration: 15,
                btn: (h) => h(
                    'a-button', {
                        props: {
                            size: 'small',
                            icon: 'question-circle'
                        },
                        on: {
                            click: () => this.$notification.error({
                                message: '错误',
                                description: '如果输入正确仍然看到这个错误，很有可能是此商品的计算公式有误，请联系管理员修改',
                                duration: 15,
                                key: 'errorCalc'
                            })
                        }
                    },
                    '我输入的内容没有错误'
                ),
                key: 'errorCalc'
            })
        },
        // 计算单个条目价格
calcSingle() {
    const isP = Number(this.selectedGoodsRule.is_p)
    if (this.innerFormModal.amount && this.selectedGoodsRule.autoWeight === '1') {
        let weight = this.innerFormModal.amount * this.selectedGoodsInfo.weight
        // is_p = 0(公斤): 保留2位小数四舍五入, is_p = 1(瓶子): 不保留小数（不四舍五入）
        if (isP === 0) {
            this.innerFormModal.weight = weight.toFixed(2)  // 四舍五入
        } else {
            this.innerFormModal.weight = Math.floor(weight).toString()  // 不四舍五入
        }
    }
    if (this.selectedGoodsRule.autoPrice === '1') {
        let result = this.solveFormula()
        if (Number.isFinite(result)) {
            // is_p = 0(公斤): 保留2位小数四舍五入, is_p = 1(瓶子): 不保留小数（不四舍五入）
            if (isP === 0) {
                this.innerFormModal.money = result.toFixed(2)  // 四舍五入
            } else {
                this.innerFormModal.money = Math.floor(result).toString()  // 不四舍五入
            }
        }
    }
},
        // 计算所有条目数据（总数量、总重量、总价）
        calcTotal() {
            this.statistic[0].value = this.tableData.reduce((p, q) => p + Number(q.amount), 0)
            this.statistic[1].value = this.tableData.reduce((p, q) => p + Number(q.weight), 0)
            this.statistic[2].value = this.tableData.reduce((p, q) => p + Number(q.money), 0)
        },
        // 提交订单
        onSubmitOrders() {
            this.showPayment = false
            let submitCallBack = () => {
                this.$util.request(this.$ctrl.order.edit, {
                    status: this.userInfo.stationId,
                    id: this.oid > 0 ? this.oid : undefined,
                    cli_id: this.selectedGuest,
                    u_id: this.userInfo.uid,
                    vehicle_id: this.formModel.vehicle_id.value,
                    paymoney: this.selectedPayment === '2' ? this.arrearsPrice : undefined,
                    //  1 支付  2 未支付
                    is_pay: this.selectedPayment !== '0' ? 1 : 2,
                    //  1 欠款  2 未欠款
                    is_arrears: this.selectedPayment === '2' ? 1 : 2,
                    //  1 营业员  2 台长  3 门卫  4 订单完成
                    order_state: this.selectedPayment !== '0' ? (this.singleType === 1 ? 2 : 3) : 1,
                    //  1 台长开单  2 营业员开单
                    single_type: 2,
                    is_type: 1,
                    pay: this.selectedPayment === '0' ? undefined : this.selectedPayment,
                    list: JSON.stringify(this.tableData),
                    sumquantity: this.statistic[0].value,
                    sumweight: this.statistic[1].value,
                    summoney: this.statistic[2].value
                }).then((res) => {
                    if (res.code === 1) {
                        this.$notification.success({
                            message: '提示',
                            description: '提交成功',
                            duration: 2
                        })
                        if (this.submitPrint) {
                            this.$emit('print', { id: res.data, printCount: this.printCount })
                        }
                        this.$emit('close', null)
                        this.unsetCachedRoute({
                            meta: {
                                cachedName: 'order_repay'
                            }
                        })
                    } else {
                        this.$notification.error({
                            message: '提示',
                            description: '提交失败'
                        })
                    }
                })
            }
            this.$notification.open({
                message: '提示',
                description: '确定要提交订单吗？',
                btn: (h) => h(
                    'a-button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                                this.$notification.close('submit')
                                submitCallBack()
                            }
                        }
                    },
                    '提交',
                ),
                key: 'submit'
            })
        }
    }
}
</script>

<style scoped lang="less">
@import "./edit.drawer.less";
</style>
